export default "__VITE_ASSET__BCDhXyDx__"